import { getStrapiMedia } from "../../utils/utils";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./HomepageCountries.scss";
import { CountriesComponent_Plain } from "../../types/components/homepage/CountriesComponent.ts";

const HomepageCountries = ({ data }: { data: CountriesComponent_Plain }) => {
  return (
    <>
      <section className="box-countries">
        <div className="wrapper">
          <div className="countries-title">
            <h2>
              {data.title} <span>{data.subTitle}</span>
            </h2>
          </div>
          <div className="countries-cont">
            <div className="countries-cont__left">
              <div className="countries-cont__title">
                {data.title2} <span>{data.subTitle2}</span>
              </div>
              <div className="countries-cont__text">
                <BlocksRenderer content={data.content} />
              </div>
            </div>
            <div className="countries-cont__right">
              {data.image ? (
                <img
                  src={getStrapiMedia(data.image.url)}
                  width="1016"
                  height="744"
                  alt={data.title}
                />
              ) : (
                ""
              )}
            </div>
            {data.button.link ? (
              <div className="countries-cont__btn">
                <a className="btn-black" href={data.button.link}>
                  {data.button.title}
                </a>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomepageCountries;
